import { action as actionCreator } from "typesafe-actions";
import { loadingHasFinished, loadingNotStarted } from "@advosys/component-react-utils";
import { actions as dynamicInvoiceDialogActions, DynamicInvoiceDialogActionTypes } from "./dynamic-invoice-dialog-store";
export var DynamicInvoiceDialogControllerActionTypes;
(function (DynamicInvoiceDialogControllerActionTypes) {
    DynamicInvoiceDialogControllerActionTypes["Initialize"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:dynamic-invoice-dialog:dynamic-invoice-dialog-controller-store:Initialize";
    DynamicInvoiceDialogControllerActionTypes["Clear"] = "@@UNIK:domains:dynamic-invoice:pages:dynamic-invoice-page:components:dynamic-invoice-dialog:dynamic-invoice-dialog-controller-store:Clear";
})(DynamicInvoiceDialogControllerActionTypes || (DynamicInvoiceDialogControllerActionTypes = {}));
export const actions = {
    initialize: (preparedInvoice) => actionCreator(DynamicInvoiceDialogControllerActionTypes.Initialize, { preparedInvoice }),
    clear: () => actionCreator(DynamicInvoiceDialogControllerActionTypes.Clear)
};
const combinedActions = {
    ...actions,
    savePreparedInvoiceSuccess: dynamicInvoiceDialogActions.savePreparedInvoiceSuccess
};
const initialState = {
    loading: loadingNotStarted
};
export const dynamicInvoiceDialogControllerReducer = (state = initialState, action) => {
    switch (action.type) {
        case DynamicInvoiceDialogControllerActionTypes.Initialize:
            return { ...state, loading: loadingHasFinished(action.payload) };
        case DynamicInvoiceDialogControllerActionTypes.Clear:
            return initialState;
        case DynamicInvoiceDialogActionTypes.SavePreparedInvoiceSuccess:
            if (state.loading.loadingState !== "has-finished")
                throw Error("Loading should be finished.");
            return { ...state, loading: loadingHasFinished({ preparedInvoice: action.payload.updatedPreparedInvoice }) };
        default:
            return state;
    }
};
